import { IFlightIssuanceState } from "@/core/interfaces/IFlightIssuance.interface";

const state: IFlightIssuanceState = {
  fetchingPNR: false,
  issueTicketLoading: false,
  financialProfilePublicId: "",
  pnrDetail: null,
  pnrDetailV3: null,
  calculatedFareV3: null,
  calculatingFareV3: false,
  pnr: "",
  isTicketIssued: false,
  isFinancialProfilesFetching: false,
  issuanceFinancialProfiles: [],
  salesUsersList: [],
  isApplyPromoCodeLoading: false,
  promoCodeResponse: null,
  hasMissingFieldsError: false,
};

export default state;
